export const itemNames: Record<string, string> = {
	iname_Gold: "Grana",
	iname_Key: "Chave",
	iname_Medikit: "Kit médico",
	iname_PowerPlantKeyCard: "Cartão da usina",
	iname_BaseKeyCard: "Cartão da base",
	iname_NightVisionEquipment: "Equipamento de visão noturna",
};
